import { MainFilterTypesMP } from '../Type';
import { MainFilterStateMarketPremium } from '../../reducers/main-filter-market-premium/Types';
import { CustomMonthsPeriodState, CustomWeeksPeriodState } from '@state/reducers/main-filter/MainFiltersReducer';
import { BaseTimePeriod } from '@services/FiltersTypes';
import { Periodicity } from '@components/time-period-selector/PeriodsTypes';
import { RelativePeriod } from '@components/comparison-period-selector/Types';
import { GrowthTypes } from '@components/comparison-growth-selector/Types';

export const updateMainFiltersMarketPremium = (payload: MainFilterStateMarketPremium) => {
  return {
    type: MainFilterTypesMP.MainFiltersUpdatedMP,
    payload,
  };
};
export const updateMainFiltersMPGrowthType = (payload: GrowthTypes): MainFiltersMarketPremiumAction => {
  return {
    type: MainFilterTypesMP.UpdateMFMPGrowthType,
    payload: payload,
  };
};
export const updateMainFiltersMPPeriod = (payload: BaseTimePeriod): MainFiltersMarketPremiumAction => {
  return {
    type: MainFilterTypesMP.UpdateMFMPPeriod,
    payload: payload,
  };
};

export const updateMainFiltersMPPeriodicity = (payload: Periodicity): MainFiltersMarketPremiumAction => {
  return {
    type: MainFilterTypesMP.UpdateMFMPPeriodicity,
    payload: payload,
  };
};

export const updateMainFiltersMPComparisonPeriod = (
  payload: RelativePeriod | BaseTimePeriod,
): MainFiltersMarketPremiumAction => {
  return {
    type: MainFilterTypesMP.UpdateMFMPComparisonPeriod,
    payload: payload,
  };
};
export const updateMainFiltersMPCustomMonthsPeriodState = (
  payload: CustomMonthsPeriodState,
): MainFiltersMarketPremiumAction => {
  return {
    type: MainFilterTypesMP.UpdateMFMPCustomMonthsPeriodState,
    payload: payload,
  };
};

export const updateMainFiltersMPCustomWeeksPeriodState = (
  payload: CustomWeeksPeriodState,
): MainFiltersMarketPremiumAction => {
  return {
    type: MainFilterTypesMP.UpdateMFMPCustomWeeksPeriodState,
    payload: payload,
  };
};

export type MainFiltersMarketPremiumAction =
  | UpdateMainFiltersMPAction
  | UpdateMFMPGrowthTypeAction
  | UpdateMFMPPeriodAction
  | UpdateMFMPPeriodicityAction
  | UpdateMFMPComparisonPeriodAction
  | UpdateMFMPCustomMonthsPeriodStateAction
  | UpdateMFMPCustomWeeksPeriodStateAction;

type UpdateMainFiltersMPAction = ActionType<MainFilterTypesMP.MainFiltersUpdatedMP> & {
  payload: MainFilterStateMarketPremium;
};

type UpdateMFMPGrowthTypeAction = ActionType<MainFilterTypesMP.UpdateMFMPGrowthType> & {
  payload: GrowthTypes;
};

type UpdateMFMPPeriodAction = ActionType<MainFilterTypesMP.UpdateMFMPPeriod> & {
  payload: BaseTimePeriod;
};

type UpdateMFMPPeriodicityAction = ActionType<MainFilterTypesMP.UpdateMFMPPeriodicity> & {
  payload: Periodicity;
};

type UpdateMFMPComparisonPeriodAction = ActionType<MainFilterTypesMP.UpdateMFMPComparisonPeriod> & {
  payload: RelativePeriod | BaseTimePeriod;
};

type UpdateMFMPCustomMonthsPeriodStateAction = ActionType<MainFilterTypesMP.UpdateMFMPCustomMonthsPeriodState> & {
  payload: CustomMonthsPeriodState;
};

type UpdateMFMPCustomWeeksPeriodStateAction = ActionType<MainFilterTypesMP.UpdateMFMPCustomWeeksPeriodState> & {
  payload: CustomWeeksPeriodState;
};

type ActionType<MainFilterTypesMP> = {
  type: MainFilterTypesMP;
};
